import React from "react";
import { Modal, Form } from "antd";

interface ModalFormProps {
  title?: any;
  visible: boolean;
  onOk: (values: any) => void;
  onCancel: () => void;
  footerProps?: any;
  Footer?: any;
  CollectedForm: any;
  formProps?: any;
  width?: string;
  okButtonProps?: any;
  destroyOnClose?: boolean;
  okText?: boolean | string;
  cancelText?: boolean | string;
  className?: string;
}

const ReModal: React.FC<ModalFormProps> = ({
  title,
  visible,
  onOk,
  onCancel,
  footerProps,
  Footer,
  CollectedForm,
  formProps,
  okButtonProps,
  width = '520px',
  destroyOnClose = false,
  okText = '確定',
  cancelText = '取消',
  className = '',
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      okText={okText}
      cancelText={cancelText}
      title={title}
      wrapClassName="tcg-modal"
      open={visible}
      width={width}
      footer={Footer === null
        ? null : Footer
          ? <Footer form={form} {...footerProps} /> : undefined
      }
      onCancel={() => {
        onCancel();
      }}
      onOk={() => {
        form.validateFields().then((values) => {
          onOk(values);
        });
      }}
      okButtonProps={okButtonProps}
      destroyOnClose={destroyOnClose}
      className={className}
    >
      <CollectedForm form={form} {...formProps} />
    </Modal>
  );
};

export default ReModal;